import { render, staticRenderFns } from "./NewEducationField.vue?vue&type=template&id=6d2d8126&scoped=true"
import script from "./NewEducationField.vue?vue&type=script&lang=js"
export * from "./NewEducationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d8126",
  null
  
)

export default component.exports